import { getStorage, setStorage } from '../../utils/stroage/stroage'
import { __TOKEN__, __USER_INFO__, __FAVORITE_CURRENCY__ } from '../../utils/stroage/nameSpace'
import { SET_TOKEN, SET_USER_INFO, SET_FAVORITE_CURRENCIES, SET_HIDE_BALANCE } from '../nameSpace'

import {
  login,
  userGetLoginInfo,
  logout,
  userFavorVcList,
  userFavorVcAdd,
  userFavorVcDelete
} from '../../api/user/user'
import { deviceId, deviceType } from '../../utils/device'

let loadingUserInfo = false

export default {
  state: {
    token: getStorage(__TOKEN__) || '',
    userInfo: getStorage(__USER_INFO__) || {},
    favoriteCurrencies: getStorage(__FAVORITE_CURRENCY__) || []
  },
  mutations: {
    [ SET_FAVORITE_CURRENCIES ] (state, favoriteCurrencies) {
      state.favoriteCurrencies = favoriteCurrencies
      setStorage(__FAVORITE_CURRENCY__, favoriteCurrencies)
    },
    [ SET_TOKEN ] (state, token) {
      state.token = token
      setStorage(__TOKEN__, token)
    },
    [ SET_USER_INFO ] (state, userInfo) {
      state.userInfo = {
        ...state.userInfo,
        ...userInfo
      }
      setStorage(__USER_INFO__, userInfo)
    }
  },
  actions: {
    deleteUserFavoriteVc ({
      commit
    }, {
      vc
    }) {
      return new Promise((resolve, reject) => {
        userFavorVcDelete({ vcId: vc.id })
          .then(res => {
            if (res.success) {
              commit(SET_FAVORITE_CURRENCIES, res.data)
              resolve(res)
            } else {
              reject(new Error(res.message))
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    addUserFavoriteVc ({
      commit
    }, {
      vc
    }) {
      return new Promise((resolve, reject) => {
        userFavorVcAdd({ vcId: vc.id })
          .then(res => {
            if (res.success) {
              commit(SET_FAVORITE_CURRENCIES, res.data)
              resolve(res)
            } else {
              reject(new Error(res.message))
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    updateUserFavoriteCurrencies ({
      commit
    }) {
      return new Promise((resolve, reject) => {
        userFavorVcList()
          .then(res => {
            if (res.success) {
              commit(SET_FAVORITE_CURRENCIES, res.data)
              resolve(res.data)
            } else {
              reject(new Error(res.message))
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    loginByUsername ({ commit, rootState }, userInfo) {
      return new Promise((resolve, reject) => {
        login({
          ...userInfo, deviceId, deviceType
        })
          .then(res => {
            if (res.success) {
              commit(SET_TOKEN, res['data'].token)
              commit(SET_USER_INFO, res['data'])
              resolve(res)
            } else {
              resolve(res)
              // reject(new Error(res.message))
            }
          })
          .catch(err => reject(err))
      })
    },
    logout ({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        logout({}).then(res => {
          if (res.success) {
            commit(SET_TOKEN, '')
            commit(SET_USER_INFO, {})
            // 清除相关缓存内容
            if (rootState.app.hideBalance) {
              commit(SET_HIDE_BALANCE, false)
            }
            commit(SET_FAVORITE_CURRENCIES, [])
            resolve(res)
          } else {
            reject(new Error(res.message))
          }
        }).catch(reject)
      })
    },
    updateUserInfo ({ commit, state }) {
      if (loadingUserInfo) return
      return new Promise((resolve, reject) => {
        loadingUserInfo = true
        userGetLoginInfo({})
          .then(res => {
            loadingUserInfo = false
            if (res.success) {
              commit(SET_USER_INFO, {
                ...state.userInfo,
                ...res.data
              })
              resolve(res)
            } else {
              reject(new Error(res.message))
            }
          })
          .catch(err => {
            loadingUserInfo = false
            return reject(err)
          })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js